import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import LoginPage from '../pages/LoginPage';
import WorkspacesPage from '../pages/WorkspacesPage';
import WorkspaceDashboard from '../pages/WorkspaceDashboard';
import DocumentLibrary from '../pages/DocumentLibrary';
import WorkspaceSearchPage from '../pages/WorkspaceSearchPage';
import QAPage from '../pages/QAPage';
import AgendaPage from '../pages/AgendaPage';
import MyAgendaPage from '../pages/MyAgendaPage';
import AdminDashboard from '../pages/AdminDashboard';
import MobileHomePage from '../pages/MobileHomePage';
import CVAppPage from '../pages/CVAppPage';
import RecruitmentHostPage from '../pages/RecruitmentHostPage';
import RecruitmentAssistantPage from '../pages/RecruitmentAssistantPage';
import ApiDiagnosticsPage from '../pages/ApiDiagnosticsPage';
import SupportSecurityPage from '../pages/SupportSecurityPage';
import TeamsBotTestPage from '../pages/TeamsBotTestPage';
// ASA-1238: na inloggen kom je in de Slimme Assistent. Dit component kent de bestemming en doet
// een ECHTE paginalading, want dat pad hoort bij een andere container achter de edge.
import NaarSlimmeAssistent from '../components/NaarSlimmeAssistent';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="v-loading">Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return <div className="v-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  // ASA-1238/AC-5: een niet-beheerder op het beheeradres gaat naar de Slimme Assistent.
  if (!isAdmin) return <NaarSlimmeAssistent />;
  return children;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/mobile" element={<PrivateRoute><MobileHomePage /></PrivateRoute>} />

      <Route path="/" element={
        <PrivateRoute><Layout /></PrivateRoute>
      }>
        {/* ASA-1238/AC-3: via-ventus.nl kaal openen brengt je op de Slimme Assistent. */}
        <Route index element={<NaarSlimmeAssistent />} />
        <Route path="my-agenda" element={<MyAgendaPage />} />
        <Route path="workspaces" element={<WorkspacesPage />} />
        <Route path="workspaces/:workspaceId" element={<WorkspaceDashboard />} />
        <Route path="workspaces/:workspaceId/documents" element={<DocumentLibrary />} />
        <Route path="workspaces/:workspaceId/search" element={<WorkspaceSearchPage />} />
        <Route path="workspaces/:workspaceId/qa" element={<QAPage />} />
        <Route path="workspaces/:workspaceId/agenda" element={<AgendaPage />} />
        <Route path="workspaces/:workspaceId/recruitment" element={<RecruitmentHostPage />} />
        <Route path="recruitment-assistant" element={<RecruitmentAssistantPage />} />
        <Route path="workspaces/:workspaceId/cv" element={<CVAppPage />} />
        <Route path="cv" element={<CVAppPage />} />
        <Route path="admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="admin/api-diagnostics" element={<AdminRoute><ApiDiagnosticsPage /></AdminRoute>} />
        <Route path="support/security" element={<SupportSecurityPage />} />
        <Route path="support/teams-bot" element={<TeamsBotTestPage />} />
      </Route>

      {/* ASA-1238/AC-4: een adres dat niet bestaat brengt je op de Slimme Assistent in plaats van
          op de werkruimtes. Dit is OOK de route waar een niet-geroute /slimme-assistent/ zou
          landen, en daarom heeft dat component een lusbeveiliging. */}
      <Route path="*" element={<NaarSlimmeAssistent />} />
    </Routes>
  );
}
